import angular from 'angular';
import uiRouter from 'angular-ui-router';
import addNewComponent from './addNew.component';

let addNewModule = angular.module('addNew', [
  uiRouter
])

.component('addNew', addNewComponent)

.name;

export default addNewModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/addNew/addNew.js